import { faRobot } from "@fortawesome/free-solid-svg-icons";
import {
  LayoutDashboard,
  Upload,
  Phone,
  FileText,
  History,
  FileCog,
  FileEdit,
  User,
  CreditCard,
  ShieldCheck,
  AudioLines,
  BarChart3,
  FilePen,
  UserPlus,
  Users,
  HistoryIcon,
  Building2, List,
  Building2Icon,
  Megaphone,
  ClipboardList,
  FolderPlus,
  PhoneCall,
  Bot,
  ListChecks
} from "lucide-react";

const SidebarData = [
  {
    id: "1",
    Title: "Dashboard",
    Link: "/dashboard",
    Icon: LayoutDashboard,
    permission: ["ivr:sidebar_dashboard"]
  },
  {
    id: "2",
    Title: "Campaigns",
    Link: "/campaigns",
    Icon: Users,
    permission: ["ivr:sidebar_campaigns"]
  },
  {
    id: "3",
    Title: "Leads",
    Link: "/leads",
    Icon: Users,
    permission: ["ivr:sidebar_leads"]
  },
  {
    id: "5",
    Title: "User Management",
    Link: "#",
    Icon: User,
    permission: ["ivr:sidebar_user_management"],
    subMenu: [
      {
        id: "5-1",
        Title: "Add User",
        Link: "/add-user",
        Icon: UserPlus,
        permission: ["ivr:sidebar_add_user"]
      },
      {
        id: "5-2",
        Title: "User List",
        Link: "/user-list",
        Icon: Users,
        permission: ["ivr:sidebar_user_list"]
      },
      {
        id: "5-3",
        Title: "Log History",
        Link: "/log-history",
        Icon: HistoryIcon,
        permission: ["ivr:log_history"]
      }
    ]
  },
  {
    id: "8",
    Title: "Company Management",
    Link: "/company-list",
    Icon: Building2,
    permission: ["ivr:sidebar_company_management"],
  },
  {
    id: "9",
    Title: "Script/Resource",
    Link: "/script-resource",
    Icon: FileText,
    permission: ["ivr:sidebar_script_resource"],
  },
  
  {
    id: "11",
    Title: "Call Numbers",
    Link: "/call-numbers",
    Icon: Phone,
    permission: ["ivr:sidebar_numbers_list"],
  },
  {
    id: "11",
    Title: "Dispositions",
    Link: "/disposition-list",
    Icon: ListChecks,
    permission: ["ivr:sidebar_disposition_list"],
  },

  {
    id: "10",
    Title: "Test Call",
    Link: "/initialize-call",
    Icon: PhoneCall,
    permission: ["ivr:sidebar_initialize_call"],
  },
  {
    id: "10",
    Title: "Calls",
    Link: "/calls",
    Icon: PhoneCall,
    permission: ["ivr:sidebar_calls"],
  },
  {
  id: "10",
  Title: "Client Assist",
  Link: "/client-assist",
  Icon:  Bot,
  permission: ["ivr:sidebar_ai_assistant"],
},
{
  id: "10",
  Title: "Agent Assist",
  Link: "/agent-assist",
  Icon:  Bot,
  permission: ["ivr:sidebar_ai_assistant"],
}

];
export default SidebarData;
